// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  assetsUrl: 'micro-apps',
  gtmId: 'GTM-MK683SC',
  apiKey: 'fbd1abee787e41eac0dd36c620fd27a6',
  apiExperience: 'https://xdig-des.apidescal.bpp.pe/channel/xdig/v1.0',
  allowDebug: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
